import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCamcorderLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "e/icon/media/camcorder_line",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M16 4C17.0544 4 17.9182 4.81588 17.9945 5.85074L18 6V8.20957L20.0944 6.91938C20.8925 6.42772 21.911 6.95748 21.9945 7.86341L22 7.98365V16.0166C22 16.9539 21.0147 17.5433 20.1997 17.1392L20.0944 17.0808L18 15.7906V18C18 19.0544 17.1841 19.9182 16.1493 19.9945L16 20H4C2.94564 20 2.08183 19.1841 2.00549 18.1493L2 18V6C2 4.94564 2.81588 4.08183 3.85074 4.00549L4 4H16ZM16 6H4V18H16V6ZM20 9.32655L18 10.5586V13.4416L20 14.6737V9.32655Z"
		})
	})
});
export default SvgCamcorderLine;
